import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Box,
} from "@mui/material";
import { useMemo, useState } from "react";
import { useBudget } from "../../../../contexts/BudgetContext/projectbudgets.context";
import {
  emptyTotalSplited,
  initialBudgetWideAppliedTaxes,
} from "../../../../types/budget/budget";
import { TaxData } from "../../../../types/budget/service-item";
import BaseValuesTotal from "../../Budget/BaseValuesTotal";
import Exchange from "../../Budget/Exchange";
import BaseValues from "../../Budget/BudgetTotals/BaseValues";
import { useServices } from "../../../../contexts/ServicesContext/projectservices.context";
import { useProject } from "../../../../contexts/project.context";

export default function GlobalAppliedTaxes() {
  // const { activeBudget, versionInfo, activeBudgetDispatch, updateBudget } =
  //   useBudget();
  const { activeService, activeServiceDispatch, updateService } = useServices();
  const { event } = useProject();
  const baseValuesTotal = useMemo(() => {
    return (
      activeService.budgetValuesTotal?.byCalculationType?.SUM?.SUM ||
      emptyTotalSplited
    );
  }, [activeService]);

  const budgetWideAppliedTaxes = useMemo(() => {
    return activeService.budgetWideAppliedTaxes[0];
  }, [activeService]);

  // const budgetWideAppliedTaxesComparison = useMemo(() => {
  //   return (
  //     activeService.budgetWideAppliedTaxes?.find(
  //       (el) => el.version === versionInfo.comparisonVersion
  //     ) || initialBudgetWideAppliedTaxes
  //   );
  // }, [activeService, versionInfo]);
  // const [localAppliedTaxes, setLocalAppliedTaxes] = useState(budgetWideAppliedTaxes)
  function handleFieldBlur(value: TaxData) {
    // setLocalAppliedTaxes({ ...localAppliedTaxes, taxData })
    // versionInfo must be a sibling of type/payload (reducer reads action.versionInfo).
    activeServiceDispatch({
      type: "NEW_GLOBAL_TAX_DATA",
      payload: {
        newBudgetWideAppliedTaxes: {
          ...budgetWideAppliedTaxes,
          taxData: value,
          version: 0,
        },
      },
      versionInfo: { comparisonVersion: 0, version: 0, status: "OPEN" },
    });
  }
  function handleExchangeSubmit(value: any) {
    // setLocalAppliedTaxes({ ...localAppliedTaxes, exchange: value })
    activeServiceDispatch({
      type: "NEW_GLOBAL_TAX_DATA",
      payload: {
        newBudgetWideAppliedTaxes: {
          ...budgetWideAppliedTaxes,
          exchange: value,
          version: 0,
        },
      },
      versionInfo: { comparisonVersion: 0, version: 0, status: "OPEN" },
    });
  }
  function handleSave(e: any) {
    updateService(activeService?._id || "", activeService, "SAVE", 0);
  }

  return (
    <Accordion>
      <AccordionSummary>
        <span>Valores</span>
      </AccordionSummary>
      <AccordionDetails>
        <BaseValues
          budgetWideAppliedTaxes={budgetWideAppliedTaxes}
          taxData={budgetWideAppliedTaxes?.taxData}
          exchange={budgetWideAppliedTaxes?.exchange}
          compareTaxData={undefined}
          compareExchange={{ date: "", currency: "BRL", value: 1 }}
          onFieldBlur={handleFieldBlur}
        />
        <Box display={"flex"} justifyContent={"flex-end"}>
          <Button onClick={handleSave} variant="outlined">
            Salvar
          </Button>
        </Box>
        <Exchange
          onSubmitExchange={handleExchangeSubmit}
          compareExchangeData={undefined}
          savedExchangeData={budgetWideAppliedTaxes?.exchange}
          eventScope={event?.eventScope}
        />

        <BaseValuesTotal totals={baseValuesTotal} showExtras={true} />
      </AccordionDetails>
    </Accordion>
  );
}
